import type { SpaceSummary } from '../types/spaces';

/**
 * Pick the space the console should default to when the URL doesn't carry
 * one. Resolution order:
 *   1. The user's last-visited space (`UserPreferences.lastSpaceId`),
 *      provided they still have access.
 *   2. The user's `defaultSpaceId` from `/me` (set at provisioning time
 *      to the Personal Space), provided they still have access.
 *   3. The Personal Space from the user's space list.
 *   4. The first space in the list.
 *   5. `undefined` if the user has no spaces at all (caller decides what
 *      to render — typically a bounce to `/`).
 */
export function resolveDefaultSpaceId(opts: {
  spaces: SpaceSummary[];
  lastSpaceId?: string;
  defaultSpaceId?: string;
}): string | undefined {
  const { spaces, lastSpaceId, defaultSpaceId } = opts;
  if (spaces.length === 0) return undefined;

  if (lastSpaceId && spaces.some((s) => s.spaceId === lastSpaceId)) {
    return lastSpaceId;
  }
  if (defaultSpaceId && spaces.some((s) => s.spaceId === defaultSpaceId)) {
    return defaultSpaceId;
  }
  const personal = spaces.find((s) => s.kind === 'personal');
  if (personal) return personal.spaceId;
  return spaces[0].spaceId;
}
